import React from 'react'
import { Image, Link } from 'newComponents'
import './styles.scss'

import twitter from '../../../images/customers/twitter.svg'

const Testimonials = () => {
  const testimonials = [
    {
      quote:
        '"I have to say @LaunchDarkly is the most underrated product out there right now. (For developer tooling)"',
      link: 'https://twitter.com/Jowanza/status/1107741537243287552',
      author: '@Jowanza',
      platform: twitter
    },
    {
      quote: '"I had no idea how much @LaunchDarkly would REVOLUTIONIZE the way I build web applications."',
      link: 'https://twitter.com/BenNadel/status/1226525763802992640',
      author: '@bennadel',
      platform: twitter
    },
    {
      quote:
        '"Thanks to @LaunchDarkly for letting me ship software features to production @honeycombio customers on demand, right from my phone at 12,000 feat in the air"',
      link: 'https://twitter.com/lizthegrey/status/1130893006264053761',
      author: '@lizthegrey',
      platform: twitter
    }
  ]

  return (
    <section className="testimonials">
      <div className="container u-padding-none-mobile">
        <div className="testimonials-header">
          <h2 className="testimonials-title">
            Innovative Teams Choose LaunchDarkly
          </h2>
          <p className="testimonials-subtitle">
            See what developers are saying about us on Twitter.
          </p>
        </div>
        <div className="testimony">
          {testimonials.map((testimony) => (
            <Link
              className="testimony-item clickable-card"
              key={testimony.quote}
              to={testimony.link}
            >
              <p className="testimony-quote">{testimony.quote}</p>
              <div className="testimony-socials">
                <Image
                  className="testimony-socials-icon"
                  image={testimony.platform}
                />
                <span className="testimony-author">{testimony.author}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Testimonials
